import type { FC, ReactNode } from 'react';
import { Inline } from '@george-labs.com/design-system';

import type { CommonItemProps } from './types';
import { ProductsListItemWrapper } from '../ProductsListItemWrapper';

type Props = CommonItemProps & {
    content: ReactNode;
};

export const ProductsListCustomItem: FC<Props> = ({
    'data-cy': dataCy,
    className,
    label,
    labelClassName,
    labelColumnWidth,
    content,
}) => (
    <ProductsListItemWrapper
        data-cy={dataCy}
        className={className}
        label={label}
        labelClassName={labelClassName}
        labelColumnWidth={labelColumnWidth}
    >
        <Inline data-cy={dataCy}>{content}</Inline>
    </ProductsListItemWrapper>
);
